import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _Date$now from "@babel/runtime-corejs3/core-js/date/now";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import { log } from '../../utils';
import Event from './event';
// 处理posmessage参数
var GenPostMsg = /*#__PURE__*/_createClass(function GenPostMsg(method, param, callback) {
  var _this = this;
  _classCallCheck(this, GenPostMsg);
  this.genid = function () {
    var idStr = _Date$now().toString(36);
    idStr += Math.random().toString(36).substr(3);
    return idStr;
  };
  this.receiveResponse = function (data) {
    //this.PromiseObj.resolve(data);
    _this.callback(data);
  };
  this.getPayload = function () {
    return {
      msgId: _this.id,
      methodName: _this.methodName,
      body: _this.plainMsg,
      type: 'request',
      invokeType: _this.invokeType
    };
  };
  this.id = this.genid();
  this.PromiseObj = {
    resolve: null,
    reject: null
  };
  this.methodName = method;
  this.plainMsg = param;
  this.invokeType = param === null || param === void 0 ? void 0 : param.invokeType;
  this.callback = callback;
  // this.result = new Promise(
  //   function (resolve, reject) {
  //     this.PromiseObj = {
  //       resolve,
  //       reject,
  //     };
  //   }.bind(this)
  // );
});
var Frame = /*#__PURE__*/_createClass(function Frame() {
  var _this2 = this;
  _classCallCheck(this, Frame);
  this.addPending = function (e) {
    _this2.pendingMsgs[e.id] = e;
  };
  this.deletePending = function (e) {
    delete _this2.pendingMsgs[e.id];
  };
  this.getPending = function (t) {
    return this.pendingMsgs[t];
  };
  this.invokeAPIInBrowserView = function (payload) {
    window.sendTo(payload);
  };
  this.invokeAPIInWebview = function (payload) {
    window.sendToHost(payload);
  };
  this.invokeAPI = function (method, param, callback) {
    var genPostMsg = new GenPostMsg(method, param, callback);
    var payload = _JSON$stringify(genPostMsg.getPayload());
    var _param$invokeType = param.invokeType,
      invokeType = _param$invokeType === void 0 ? '' : _param$invokeType;
    invokeType === 'browserView' ? _this2.invokeAPIInBrowserView(payload) : _this2.invokeAPIInWebview(payload);
    _this2.addPending(genPostMsg);
    return genPostMsg;
  };
  this.handleCallback = function (datas, invokeType) {
    var type = datas.type,
      methodName = datas.methodName,
      eventName = datas.eventName,
      msgId = datas.msgId,
      _datas$data = datas.data,
      data = _datas$data === void 0 ? {} : _datas$data,
      code = datas.code,
      message = datas.message,
      msg = datas.msg;
    if (type === 'request') {
      // 壳子的调用
      switch (methodName) {
        case 'refresh':
          window.location.reload();
          break;
        case 'back':
          window.history.back();
          break;
        case 'forward':
          window.history.forward();
          break;
        case 'event':
          Event.execEvent(eventName, data);
          break;
        case 'zoomInClick':
          var scrollTopVal = document.documentElement.scrollTop || document.body.scrollTop,
            url = window.location.href;
          if (invokeType === 'browserView') {
            window.sendTo(_JSON$stringify({
              type: type,
              methodName: methodName,
              body: {
                scrollTopVal: scrollTopVal,
                url: url,
                title: data && data.title
              }
            }));
          } else {
            window.sendToHost(_JSON$stringify({
              type: type,
              methodName: methodName,
              body: {
                scrollTopVal: scrollTopVal,
                url: url,
                title: data && data.title
              }
            }));
          }
          break;
        default:
          break;
      }
    } else if (type === 'response') {
      // 响应壳子的回调
      var pending = _this2.getPending(msgId);
      pending && pending.receiveResponse({
        data: data,
        code: code,
        message: message || msg || data.msg || data.message
      });
      code != -3 && _this2.deletePending(msgId);
    }
  };
  this.init = function () {
    window.addEventListener('message', function (msg) {
      log('electron res: ', msg);
      _this2.handleCallback(msg.data || {});
    });
    window.receiveBrowserViewData && window.receiveBrowserViewData(function (e, response) {
      return _this2.handleCallback(response);
    });
  };
  this.pendingMsgs = {};
});
var frame = new Frame();
export default frame;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/helper/pcIframe.js
// module id = null
// module chunks = 